import { rest } from 'msw'
import mockContacts from '../../../__mocks__/Contacts/contacts.json'

export const getContacts = rest.get(`${API_URL}/platform/v1/contacts`, async (req, res, ctx) => {
  return res(ctx.json(mockContacts))
})

export default [getContacts]
